import './modal-unassign-staff.scss';
import React, { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import { Box, Snackbar, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import apiClient from '../../../../utils/apiClient';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 518,
  textAlign: 'center',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function ModalUnassignStaff({ open, onClose, staffData, retailerId }) {
  const { t } = useTranslation();
  const token = sessionStorage.getItem('token') || null;

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('');

  // Estado para los detalles del GM obtenidos de la API
  const [staffDetails, setStaffDetails] = useState(null);

/*  console.log('xx');
  console.log(staffData);*/

  // Llamada a la API cuando se abre la modal
  useEffect(() => {
    if (staffData && staffData.email) {

      const fetchGMData = async () => {
        try {
          const response = await apiClient.get(
            `${process.env.REACT_APP_API_URL}/retailer/staff-member?staffEmail=${encodeURIComponent(staffData.email)}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
              }
            }
          );
          if (response.status === 200) {
            setStaffDetails(response.data);
          }
        } catch (error) {
          console.error('Error fetching GM data:', error);
          setSnackbarMessage(t('common-internal-server-error'));
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      };
      fetchGMData();
    }
  }, [staffData, token, t]);

  const onSubmit = async () => {
    // Filtrar los retailers excluyendo el que coincide con retailerId
    const filteredRetailers = staffDetails.retailerInfo.filter(
      (retailer) => retailer.id !== parseInt(retailerId) // Excluir el retailer con id igual al retailerId
    );
    //console.log('retailercodes')
    // Construir la cadena de retailer_codes, como el primer valor y luego los demás retailer_codes separados por comas
    const retailerCodes = filteredRetailers.map((retailer) => retailer.retailer_code).join(',');
    //console.log(retailerCodes)

    const payload = {
      ids_retailer: `${retailerCodes}`
    };

    try {
      const response = await apiClient.patch(
        `${process.env.REACT_APP_API_URL}/retailer/retailer-staff-rel/${staffData.id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        }
      );

      if (response.status === 200) {
        setSnackbarMessage(t('admin-unassign-retailergm-ok'));
        setSnackbarOpen(true);
        setSnackbarSeverity('success');
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }

    } catch (error) {

      setSnackbarMessage(t('common-internal-server-error'));
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Modal open={open} onClose={handleClose} className="modal-unassign-staff">
        <Box sx={style}>
          <button
            className="close"
            onClick={handleClose}
          >
            <span className="icon-close"></span>
          </button>
          <h2>{t('admin-unassign-retailergm-title')}</h2>
          <p>{t('admin-unassign-retailergm-text')}</p>

          {/* Mostrar los detalles del GM si los datos fueron obtenidos */}
          {staffDetails ? (
            <>
              <p>{staffDetails.name} {staffDetails.last_name}</p>
              <p>{staffDetails.email}</p>
            </>
          ) : (
            <p>{t('common-loading')}</p> // Mensaje mientras cargan los datos
          )}

          <div className="actions">
            <button className="btn secondary" onClick={handleClose}>
              {t('common-cancel')}
            </button>
            <button className="btn" onClick={onSubmit}>
              {t('admin-unassign-retailergm-action')}
            </button>
          </div>
        </Box>
      </Modal>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
      >
        <Alert severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default ModalUnassignStaff;
